import styled from 'styled-components';
import React, { FC } from 'react';
import { Trans, useTranslation, withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { connect, useDispatch } from 'react-redux';
import { compose } from 'react-recompose';
import { Container, ElasticTheme as Theme, RobotIcon, TertiaryButton } from '@dev/ee-components';
import { Grid } from '@material-ui/core';
import { goBack } from 'redux-first-history';

import { ApplicationState as State } from '@/store';
import { useMobile } from '@/services/hooks/useMobile';
import { ErrorProps } from '../ErrorInterface';
import { CustommerSupportButton } from '../CustomerSupportButton';

const ErrorCode = styled.h2`
    color: ${Theme.palette.grey[400]};
    font-family: Nunito;
    font-size: 16px;
    font-weight: 600;
`;

const Description = styled.div`
    margin: 1.3125em 0;
`;

const Title = styled.div`
    color: #32325c;
    font-size: 28px;
    font-family: Nunito;
    font-weight: 400;
    line-height: 38px;
    letter-spacing: 0em;
    text-align: left;
`;

const styles = {};

const mapState = (state: State, ownProps: ErrorProps): ErrorProps => ({
    ...ownProps,
    browser: state.browser,
});

const E500: FC = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isMobile = useMobile();

    return (
        <Container>
            <Grid container alignItems="center" wrap="wrap">
                <Grid item xs={12} sm={6}>
                    <ErrorCode>Error 500</ErrorCode>
                    <Title>{t('error500_title')}</Title>
                    <Description>
                        <Trans
                            i18nKey="error500_desc"
                            components={{
                                supportButton: <CustommerSupportButton />,
                                goBackButton: (
                                    <TertiaryButton
                                        text={t('previouspage')}
                                        onClick={(): void => {
                                            dispatch(goBack());
                                        }}
                                        size="small"
                                    />
                                ),
                            }}
                        />
                    </Description>
                </Grid>
                <Grid item xs={12} sm={6}>
                    {!isMobile && <RobotIcon width={600} height={390} />}
                </Grid>
            </Grid>
        </Container>
    );
};

export default compose(withStyles(styles), withTranslation(), connect<ErrorProps>(mapState))(E500);
